import { useState } from 'react';
import MarketingNav from './MarketingNav';
import MarketingFooter from './MarketingFooter';

export default function MarketingContact() {
  const [form, setForm] = useState({ name: '', organisation: '', email: '', message: '' });
  const [status, setStatus] = useState('idle'); // idle | submitting | success | error

  const handleChange = (e) => setForm((f) => ({ ...f, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('submitting');
    try {
      const res = await fetch('/api/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });
      if (!res.ok) throw new Error('Request failed');
      setStatus('success');
      setForm({ name: '', organisation: '', email: '', message: '' });
    } catch {
      setStatus('error');
    }
  };

  return (
    <div className="bg-[#F0F9FF] min-h-screen flex flex-col">
      <MarketingNav />

      <section className="bg-[#0A2540] text-white py-16 px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-4xl font-bold mb-4">Get in touch</h1>
          <p className="text-slate-300 text-lg">
            Interested in Early Access or have questions? We'd love to hear from you.
          </p>
        </div>
      </section>

      <section className="py-20 px-6">
        <div className="max-w-4xl mx-auto grid md:grid-cols-5 gap-12">
          {/* Contact details */}
          <div className="md:col-span-2 space-y-6">
            <div>
              <h3 className="text-sm font-semibold text-[#0A2540] uppercase tracking-wider mb-2">Email</h3>
              <p className="text-[#64748B] text-sm">hello@scriverahealth.com</p>
            </div>
            <div>
              <h3 className="text-sm font-semibold text-[#0A2540] uppercase tracking-wider mb-2">Website</h3>
              <p className="text-[#64748B] text-sm">scriverahealth.com</p>
            </div>
            <div>
              <h3 className="text-sm font-semibold text-[#0A2540] uppercase tracking-wider mb-2">Incubated by</h3>
              <p className="text-[#64748B] text-sm">Darrel Technologies Ltd, Ghana</p>
            </div>
          </div>

          {/* Form */}
          <div className="md:col-span-3">
            {status === 'success' ? (
              <div className="bg-teal-50 border border-teal-200 rounded-2xl p-8 text-center">
                <div className="text-3xl mb-3">✅</div>
                <h3 className="text-lg font-semibold text-[#0A2540] mb-2">Message received!</h3>
                <p className="text-[#64748B] text-sm">We'll be in touch shortly.</p>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="bg-white rounded-2xl p-8 border border-slate-100 shadow-sm space-y-5">
                <div>
                  <label className="block text-sm font-medium text-[#0F172A] mb-1" htmlFor="name">Full name</label>
                  <input
                    id="name"
                    name="name"
                    type="text"
                    required
                    value={form.name}
                    onChange={handleChange}
                    className="w-full border border-slate-200 rounded-lg px-4 py-2.5 text-sm text-[#0F172A] focus:outline-none focus:ring-2 focus:ring-[#0E7490]"
                    placeholder="Dr. Ama Owusu"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-[#0F172A] mb-1" htmlFor="organisation">Organisation</label>
                  <input
                    id="organisation"
                    name="organisation"
                    type="text"
                    value={form.organisation}
                    onChange={handleChange}
                    className="w-full border border-slate-200 rounded-lg px-4 py-2.5 text-sm text-[#0F172A] focus:outline-none focus:ring-2 focus:ring-[#0E7490]"
                    placeholder="Accra Specialist Hospital"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-[#0F172A] mb-1" htmlFor="email">Email address</label>
                  <input
                    id="email"
                    name="email"
                    type="email"
                    required
                    value={form.email}
                    onChange={handleChange}
                    className="w-full border border-slate-200 rounded-lg px-4 py-2.5 text-sm text-[#0F172A] focus:outline-none focus:ring-2 focus:ring-[#0E7490]"
                    placeholder="you@hospital.gh"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-[#0F172A] mb-1" htmlFor="message">Message</label>
                  <textarea
                    id="message"
                    name="message"
                    required
                    rows={4}
                    value={form.message}
                    onChange={handleChange}
                    className="w-full border border-slate-200 rounded-lg px-4 py-2.5 text-sm text-[#0F172A] focus:outline-none focus:ring-2 focus:ring-[#0E7490] resize-none"
                    placeholder="Tell us about your facility and what you're looking for..."
                  />
                </div>

                {status === 'error' && (
                  <p className="text-sm text-red-600">Something went wrong. Please try again.</p>
                )}

                <button
                  type="submit"
                  disabled={status === 'submitting'}
                  className="w-full bg-[#0A2540] text-white font-semibold py-3 rounded-lg hover:bg-[#0E7490] transition-colors disabled:opacity-60"
                >
                  {status === 'submitting' ? 'Sending…' : 'Send message'}
                </button>
              </form>
            )}
          </div>
        </div>
      </section>

      <MarketingFooter />
    </div>
  );
}
